// extracted by mini-css-extract-plugin
export default {"suffix":"Sidebar_suffix__D8tqh","btn":"Sidebar_btn__xf6sI","logoContainer":"Sidebar_logoContainer__TIcRy"};